import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export function LegalPage({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="pt-32 pb-20">
        <div className="mx-auto max-w-3xl px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" /> Powrót do strony głównej
          </Link>

          <h1 className="mt-6 font-display text-4xl font-bold md:text-5xl">{title}</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            Ostatnia aktualizacja: {lastUpdated}
          </p>

          <div
            className="prose-legal mt-10 space-y-4 text-sm leading-relaxed text-muted-foreground
              [&_h2]:mt-10 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-foreground
              [&_p]:my-3
              [&_strong]:text-foreground
              [&_a]:text-primary [&_a]:underline
              [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_ul]:my-3"
          >
            {children}
          </div>

          <div className="mt-16 rounded-2xl border border-border bg-card/40 p-6 text-sm">
            <p className="font-semibold">Masz pytania?</p>
            <p className="mt-1 text-muted-foreground">
              Napisz na{" "}
              <a href="mailto:kontakt@synctech.pl" className="text-primary underline">
                kontakt@synctech.pl
              </a>{" "}
              — odpowiadamy w ciągu 24h.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
